var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"src":_vm.src,"alt":"","width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }